import SubscriptionPackage from '@/entities/SubscriptionPackage.js';
import api from '@/services/Api';

export default {
  getPackages() {
    return api().get('/subscription/packages')
      .then(resp => resp.map(i => new SubscriptionPackage(i)));
  },

  calculateCost({ packageId, managedAccountBrandIds, couponCode }) {
    const data = { package_id: packageId };
    if (typeof couponCode !== 'undefined' && couponCode !== null) {
      data.coupon_code = couponCode;
    }

    const query = new URLSearchParams(data);
    if (Array.isArray(managedAccountBrandIds)) {
      managedAccountBrandIds.forEach(id => query.append('managed_account_brand_ids[]', id));
    }

    return api().get('/subscription/cost?' + query.toString());
  },

  change({ packageId, managedAccountBrandIds, couponCode }) {
    const data = { package_id: packageId };
    if (typeof couponCode !== 'undefined' && couponCode !== null) {
      data.coupon_code = couponCode;
    }
    if (Array.isArray(managedAccountBrandIds)) {
      data.managed_account_brand_ids = managedAccountBrandIds;
    }

    return api().put('/subscription', data);
  },

  cancel() {
    return api().delete('/subscription');
  },

  currentUsage() {
    return api().get('/subscription/current-usage')
      .then(resp => {
        resp.billing_period_begin = new Date(resp.billing_period_begin);
        resp.billing_period_end = new Date(resp.billing_period_end);

        return resp;
      });
  },

  hadPreviousSubscription() {
    return api().get('/subscription/had-previous-subscription');
  },
};
